<template lang="pug">
  span
    v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="320" nudge-bottom="8" z-index="11")
      template(v-slot:activator="{ on, attrs }")
        v-btn.px-2.button-text-normal.button-filter.text-none(v-if="currentVisit" outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
          .text-xs.font-semibold {{ $t('visit_frequency') }}
          .px-1.neutral400--text |
          .text-xs.primary--text.font-medium {{ currentVisit.label }}
          v-icon.ml-1(size=16) $yzi-chevron-down
        v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(size=13) $yzi-plus-circle
          .text-xs.text-none.font-semibold {{ $t('visit_frequency') }}
      // Filter list
      .white
        .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ $t('visit_frequency').toLowerCase() }}
        v-radio-group.mx-0.mt-0(v-model="selectedVisit")
          template(v-for="(visit, visitIdx) in visits")
            v-radio.px-4(:value="visit" :key="`visit-${visit.value}`")
              template(v-slot:label)
                .text-sm.font-normal.primary--text {{ visit.label }}
      // Actions
      .bottom-0.sticky.z-1.white
        .d-flex.align-center.px-4.py-3.border-t
          .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledClear" @click="clear") {{ $t('clear') }}
          v-spacer
          v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledApply") {{ $t('apply') }}
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  props: ['filter'],
  data() {
    return {
      showMenu: false,
      searchText: '',
      visits: [
        {
          label: `1 ${this.$t('visit').toLowerCase()}`,
          value: 1
        },
        {
          label: `2 ${this.$t('visit').toLowerCase()}s`,
          value: 2
        },
        {
          label: `3 ${this.$t('visit').toLowerCase()}s`,
          value: 3
        },
        {
          label: `4 ${this.$t('visit').toLowerCase()}s`,
          value: 4
        },
        {
          label: `More than 5 ${this.$t('visit').toLowerCase()}s`,
          value: '5+'
        }
      ],
      currentVisit: null,
      selectedVisit: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disabledApply() {
      if (this.selectedVisit === null) return true

      if (this.currentVisit) return this.selectedVisit.value === this.currentVisit.value

      return false
    },
    disabledClear() {
      return this.selectedVisit === null
    }
  },
  watch: {
    filter: {
      handler() {
        if (!this.filter.key) {
          this.clearData()
        }
      }
    },
    showMenu(value) {
      if (value && this.currentVisit) {
        this.selectedVisit = {...this.currentVisit}
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    clear() {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData() {
      this.selectedVisit = null
      this.currentVisit = null
    },
    apply() {
      this.showMenu = false
      this.currentVisit = {...this.selectedVisit}
      const key = this.selectedVisit.value === '5+' ? 'total_visit__gte' : 'total_visit'
      const value = this.selectedVisit.value === '5+' ? 5 : this.selectedVisit.value
      this.$emit('update:filter', {key, value})
    },
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}

.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>